/**
 * 地域を扱うモデル。
 * @module app/model/Region
 */
define([
    'idis/store/CacheStoreModel',
    'idis/store/CacheTreeRest'
], function(CacheStoreModel, CacheTreeRest) {
    /**
     * シングルトンを返す。
     */
    return new CacheStoreModel({
        store: new CacheTreeRest({
            target: '/dojo/app/region/region.geojson'
        })
    });
});

